
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 448 448","fill":"currentColor"}},[_c('path',{attrs:{"d":"M245.333 405.333v-42.666h-42.666v42.666H96V448h256v-42.667zM224 0l-98.56 98.133 28.373 28.16 38.614-38.613 10.24-21.333v187.52h42.666V67.2l9.814 20.053 39.04 39.04 29.013-26.88z"}}),_c('path',{attrs:{"d":"M352 42.667v42.666h42.667V320H53.333V85.333H96V42.667H10.667v320h426.666v-320z"}})])
      }
    
      }
    